import { ExclamationCircleOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { WarningColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconExclamationCircleOutlinedWarning: FunctionComponent<IBTIconProps> = (
    baseProps,
) => {
    const [props] = useAntIcon(baseProps);

    return <ExclamationCircleOutlined {...props} style={{ ...props.style, color: WarningColor }} />;
};
